<template>
  <div
  class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 mb-5 box p-3 tamano-texto"
  >
    <div
    v-for="(row,k) in getRequestDomain"
    :key="k"
    >
      <div>({{k}}). {{row.name}} </div>
      <div class="item" :class="row.cssClass" />
    </div>
  </div>
</template>

<script>
import useLegends from './useLegends'
export default {
  name: 'RequestLegends',
  setup () {
    const { getRequestDomain } = useLegends()
    return {
      getRequestDomain
    }
  }
}
</script>

<style scoped>
.item{
  height: 15px;
  width: 30px;
  border-radius: 2px;
}
.tamano-texto{
  font-size:12px;
}
</style>
